export default "__VITE_ASSET__DXcwbjlJ__"